var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3446 7.5C6.3446 10.525 8.8196 13 11.8446 13C14.8696 13 17.3446 10.525 17.3446 7.5C17.3446 4.475 14.8696 2 11.8446 2C8.8196 2 6.3446 4.475 6.3446 7.5ZM16.0505 7.5C16.0505 9.81324 14.1578 11.7059 11.8446 11.7059C9.53137 11.7059 7.63872 9.81324 7.63872 7.5C7.63872 5.18676 9.53137 3.29412 11.8446 3.29412C14.1578 3.29412 16.0505 5.18676 16.0505 7.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8372 20.8102C16.7372 14.6633 7.2628 14.6633 2.16277 20.8102C1.89701 21.1305 1.9675 21.6015 2.29549 21.8475C2.62558 22.0951 3.08795 22.0238 3.34848 21.7133C7.85082 16.3475 16.1492 16.3475 20.6515 21.7133C20.9121 22.0238 21.3744 22.0951 21.7045 21.8475C22.0325 21.6015 22.103 21.1305 21.8372 20.8102Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.3a885c68b935153df4ec478dfcc1fee4.svg";
export { ForwardRef as ReactComponent };